import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../environments/environment';
import { Router } from '@angular/router';
import { MobileZoomService } from '../common/mobile-zoom/mobile-zoom.service';
import { MatPaginator, MatDialog } from '@angular/material';
import { MapDialogComponent } from '../utility/map-dialog/map-dialog.component';
import moment from 'moment';
import * as XLSX from 'xlsx';

// 担当清掃員
export interface RecruitStaff {
  nameStaff: string;
  active: boolean;
  startDay: string;
  endDay: string;
  endPlanned: boolean;
  endKind: string;
}

// 募集の行（tbl_recruit）。日付は画面では yyyy-MM-dd の文字で持つ
export interface Recruit {
  id: number;
  cdSite: string;
  cdContract: string;
  employmentSecurityOffice: string;
  startDateRecruit: string;
  endDateRecruit: string;
  medium: string;
  status: string;
  wage: number;
  requestNo: string;
  createdUser?: string;
  // 完了・削除した日時（履歴に出す）
  deleteDate?: string;
  // 画面だけで使う
  isNew?: boolean;
  saving?: boolean;
  // 何かを変えた（保存ボタンを活かす。保存すると一覧を取り直すので消える）
  dirty?: boolean;
}

// 契約（比べる日の時点の状態）
export interface RecruitContract {
  cdSite: string;
  cdContract: string;
  workName: string;
  startDateContract: string;
  // 契約終了日（無ければ null）
  endDateContract: string;
  staffCount: number;
  state: string;
  isShort: boolean;
  // 検索条件に当たった契約（false は同じ物件の参考。薄い1行で出す）
  hit: boolean;
  recruiting: boolean;
  expired: boolean;
  soon: boolean;
  decided: boolean;
  mon: string; tue: string; wed: string; thu: string; fri: string; sat: string; sun: string;
  specificTime: number;
  garbage: number;
  holiday: number;
  companyHoliday: number;
  // 曜日ごとの不足時間（月）と、札に出す文（「第4週 3h・第1,3,5週 1h」など。不足が無ければ null）
  shortMon: number; shortTue: number; shortWed: number; shortThu: number; shortFri: number; shortSat: number; shortSun: number;
  textMon: string; textTue: string; textWed: string; textThu: string; textFri: string; textSat: string; textSun: string;
  // 不足の合計（月／1週間あたり）と、この契約の過不足（月／1週間あたり）
  shortTotal: number;
  shortTotalWeek: number;
  diffMonth: number;
  diffWeek: number;
  monthlyHours: string;
  monthlyFee: string;
  hourlyWage: string;
  minWagePref: string;
  minWage: number;
  minWageStart: string;
  shortFrom: string;
  staffs: RecruitStaff[];
  recruits: Recruit[];
  history: Recruit[];
  // 画面だけで使う
  showHistory?: boolean;
  // 検索条件に当たらない契約（薄い1行）を押して開いた
  expanded?: boolean;
}

// 物件
export interface RecruitSite {
  cdSite: string;
  nameSite: string;
  client1: string;
  client2: string;
  zip: string;
  address: string;
  // 物件の合計（月）と、1週間あたり
  siteConM: number;
  siteInsM: number;
  siteDiffM: number;
  siteCon: number;
  siteIns: number;
  siteDiff: number;
  siteShort: boolean;
  // 最寄り駅と徒歩（RP の物件概要書。この画面からも保存できる）
  nearestStation: string;
  walkMinutes: number;
  minWagePref: string;
  minWage: number;
  minWageStart: string;
  totalSites: number;
  // 上の件数（絞り込みに関係なく、その時期の時間不足の物件数）
  needSites: number;
  contracts: RecruitContract[];
  // 画面だけで使う（最寄り駅の保存中・変えた）
  stationSaving?: boolean;
  stationDirty?: boolean;
}

@Component({
  selector: 'app-recruit',
  templateUrl: './recruit.component.html',
  styleUrls: ['./recruit.component.less']
})

export class RecruitComponent implements OnInit, OnDestroy {

  // 比べる時点は1か月後に固定（2・3か月後の切り替えは「眺めるだけで募集には使わない」ので無くした。先の退職は MAP の▲で見る。
  // 裏の API は何か月後かを受け取れるままなので、必要になれば画面だけで戻せる）
  months = 1;
  // 比べる日（判定の説明に出す）
  compareDay = moment().add(1, 'M').format('YYYY/MM/DD');

  // 状態（sn：清掃員なし・不足あり／ss：清掃員あり・不足あり／on：清掃員なし・不足なし／ok：清掃員あり・不足なし）
  states = { sn: true, ss: true, on: false, ok: false };
  stateNames = { sn: '清掃員なし・不足あり', ss: '清掃員あり・不足あり', on: '清掃員なし・不足なし', ok: '清掃員あり・不足なし' };

  // 募集状況（何も押していなければ全部。押したものをもう一度押すと外れる）
  // 「決定」で保存した募集は完了して履歴に移るので、今の募集に決定の行は無い（絞り込みも無し）
  recruit = 'all';
  recruitChoices = [
    { value: 'nowRecruiting', name: '募集中' },
    { value: 'notRecruiting', name: '未募集' },
    { value: 'soon', name: '期限まで7日以内' },
    { value: 'expired', name: '期限切れ' }
  ];

  // 絞り込み
  nameSite = '';
  address = '';
  medium = '';
  hello = '';

  // 曜日
  weekList = [
    { key: 'mon', short: 'shortMon', text: 'textMon', name: '月' },
    { key: 'tue', short: 'shortTue', text: 'textTue', name: '火' },
    { key: 'wed', short: 'shortWed', text: 'textWed', name: '水' },
    { key: 'thu', short: 'shortThu', text: 'textThu', name: '木' },
    { key: 'fri', short: 'shortFri', text: 'textFri', name: '金' },
    { key: 'sat', short: 'shortSat', text: 'textSat', name: '土' },
    { key: 'sun', short: 'shortSun', text: 'textSun', name: '日' }
  ];

  // 一覧（物件ごと）
  sites: RecruitSite[] = [];
  // 検索に当たった物件の数
  totalSites = 0;
  // 上のまとめ（絞り込みに関係なく、その時期の時間不足の物件数）
  summary = { needSites: 0 };

  // 今日（yyyy-MM-dd）
  today = moment().format('YYYY-MM-DD');

  // ローディング中：true　終了：false
  nowLoading = true;
  // ダウンロード中
  downloading = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });
  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      "X-LoginAccessKey": localStorage.getItem("accessKey")
    })
  };

  constructor(private http: HttpClient, private router: Router, private dialog: MatDialog, private cdr: ChangeDetectorRef, public mz: MobileZoomService) { }

  /**
   * ほかの画面へ移るときは viewport を元に戻す
   */
  ngOnDestroy() {
    this.mz.leave();
  }

  ngOnInit() {
    // スマホ：PC と同じ見た目を縮めて出す（MobileZoomService）
    this.mz.enter();

    // 前回の検索条件
    this.nameSite = localStorage.getItem('recruit_name_site') || '';
    this.address = localStorage.getItem('recruit_address') || '';
    this.medium = localStorage.getItem('recruit_medium') || '';
    this.hello = localStorage.getItem('recruit_hello') || '';
    this.recruit = localStorage.getItem('recruit_recruit') || 'all';
    const states = localStorage.getItem('recruit_states');
    if (states) {
      try {
        const s = JSON.parse(states);
        this.states = { sn: !!s.sn, ss: !!s.ss, on: !!s.on, ok: !!s.ok };
      } catch (e) { }
    }
  }

  ngAfterViewInit() {
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 20;
    this.getRecruitData();

    this.paginator.page.subscribe(() => {
      this.getRecruitData();
    });

    this.cdr.detectChanges();
  }

  /**
   * 取得・登録に失敗したとき
   * サインインが切れているときだけ最初の画面へ戻す
   * @returns 最初の画面へ戻したら true
   */
  isSignOut(error): boolean {
    if (error && (error.status == 401 || error.status == 403)) {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
      return true;
    }
    return false;
  }

  /**
   * 検索条件の文字（一覧とエクスポートで同じ）
   */
  queryString(): string {
    const states = Object.keys(this.states).filter(k => this.states[k]).join(',');
    return 'months=' + this.months
      + '&nameSite=' + encodeURIComponent(this.nameSite)
      + '&address=' + encodeURIComponent(this.address)
      + '&medium=' + encodeURIComponent(this.medium)
      + '&hello=' + encodeURIComponent(this.hello)
      + '&states=' + states
      + '&recruit=' + this.recruit;
  }

  /**
   * 検索条件を変えたとき（1ページ目から）
   */
  search() {
    this.paginator.pageIndex = 0;
    this.getRecruitData();
  }

  /**
   * 状態のチップを押したとき
   */
  toggleState(key: string) {
    this.states[key] = !this.states[key];
    this.search();
  }

  /**
   * 募集状況を押したとき（押しているものをもう一度押すと外れて全部になる）
   */
  changeRecruit(value: string) {
    this.recruit = this.recruit == value ? 'all' : value;
    this.search();
  }

  /**
   * 一覧の取得（物件ごと。ページは物件数）
   */
  getRecruitData() {
    localStorage.setItem('recruit_name_site', this.nameSite);
    localStorage.setItem('recruit_address', this.address);
    localStorage.setItem('recruit_medium', this.medium);
    localStorage.setItem('recruit_hello', this.hello);
    localStorage.setItem('recruit_recruit', this.recruit);
    localStorage.setItem('recruit_states', JSON.stringify(this.states));

    this.nowLoading = true;

    this.http.get(
      API_BASE_URL + '/api/v1/recruit?index=' + this.paginator.pageIndex
      + '&size=' + this.paginator.pageSize
      + '&' + this.queryString(),
      {headers: this.headers}
    )
    .subscribe(res => {
      const data = (res as RecruitSite[]) || [];
      data.forEach(site => this.prepareSite(site));
      this.sites = data;
      this.totalSites = data.length > 0 ? data[0].totalSites : 0;
      if (data.length > 0) {
        this.summary = { needSites: data[0].needSites };
      }
      this.nowLoading = false;
    },
    error => {
      this.nowLoading = false;
      if (this.isSignOut(error)) return;
      alert('欠員募集の取得に失敗しました。');
    });
  }

  /**
   * 取得した物件を画面用に整える（日付の形など）
   */
  prepareSite(site: RecruitSite) {
    (site.contracts || []).forEach(con => {
      con.recruits = (con.recruits || []).map(r => this.prepareRecruit(r));
      con.history = (con.history || []).map(r => this.prepareRecruit(r));
      this.weekList.forEach(w => {
        // 出勤形態は改行で付いてくるので空白にする
        if (con[w.key]) con[w.key] = String(con[w.key]).replace(/\n/g, ' ');
      });
    });
  }

  prepareRecruit(r: Recruit): Recruit {
    r.startDateRecruit = r.startDateRecruit ? moment(r.startDateRecruit).format('YYYY-MM-DD') : '';
    r.endDateRecruit = r.endDateRecruit ? moment(r.endDateRecruit).format('YYYY-MM-DD') : '';
    r.status = r.status ? String(r.status) : '2';
    return r;
  }

  /**
   * 状態の札の種類（CSS 用）
   */
  stateClass(state: string): string {
    return 'state-' + state;
  }

  /**
   * 物件の札（不足の契約があれば赤、無ければ緑）
   */
  siteClass(site: RecruitSite): string {
    return site.siteShort ? 'site-short' : 'site-ok';
  }

  /**
   * 不足の曜日（不足時間が 0 より大きい曜日）
   */
  shortDays(con: RecruitContract) {
    return this.weekList.filter(w => Number(con[w.short]) > 0);
  }

  /**
   * 契約時間がある曜日
   */
  workDays(con: RecruitContract) {
    return this.weekList.filter(w => con[w.key]);
  }

  /**
   * 祝日区分の文言（100：FULL、0：無、それ以外は時間）
   */
  holidayText(value): string {
    if (value === null || value === undefined || value === '') return '祝日 -';
    const n = Number(value);
    if (n === 100) return '祝日 FULL';
    if (n === 0) return '祝日 無';
    return '祝日 ' + n + 'h';
  }

  /**
   * 祝日勤務があるか（札を濃くする）
   */
  hasHoliday(value): boolean {
    return value !== null && value !== undefined && value !== '' && Number(value) !== 0;
  }

  /**
   * 薄い1行（検索条件に当たらなかった契約）の清掃員の名前（比べる日に働いている人だけ。「、」区切り）
   */
  activeStaffNames(con: RecruitContract): string {
    const names = (con.staffs || []).filter(st => st.active).map(st => st.nameStaff);
    return names.length > 0 ? names.join('、') : '担当なし';
  }

  /**
   * 清掃員の欄の文言（名前　MM/DD～ ／ 名前　MM/DD 終了）
   */
  staffText(st: RecruitStaff): string {
    let text = st.nameStaff;
    if (st.startDay) {
      text += '　' + this.monthDay(st.startDay) + '～';
    }
    if (st.endDay) {
      const kind = st.endKind == '作業終了' ? '終了' : (st.endKind || '終了');
      text += '　' + this.monthDay(st.endDay) + ' ' + kind + (st.endPlanned ? '予定' : '');
    }
    return text;
  }

  /**
   * yyyy/MM/dd → MM/DD
   */
  monthDay(day: string): string {
    return day && day.length >= 10 ? day.substring(5) : day;
  }

  /**
   * 募集の行の色（清掃員が未決定のときだけ。期限まで7日以内は黄、期限切れは赤）
   */
  recruitClass(r: Recruit): string {
    if (r.status != '2' || !r.endDateRecruit) return '';
    const end = moment(r.endDateRecruit);
    const today = moment(this.today);
    const diff = end.diff(today, 'days');
    if (diff < 0) return 'expired';
    if (diff < 8) return 'soon';
    return '';
  }

  /**
   * 募集を追加（同じ契約に別の媒体など）
   * 既に募集の行があれば一番下の行から、無ければ履歴の一番新しい行から、期間と清掃員（決定・未決定）以外を写す
   */
  addRecruit(site: RecruitSite, con: RecruitContract) {
    const last = con.recruits.length > 0 ? con.recruits[con.recruits.length - 1]
      : (con.history.length > 0 ? con.history[0] : null);
    // 時給の初期値：前の行の時給（県の最低賃金より低ければ最低賃金）。前の行が無ければ県の最低賃金
    const minWage = site.minWage ? Number(site.minWage) : null;
    let wage = last && last.wage !== null && last.wage !== undefined && String(last.wage) !== '' ? Number(last.wage) : minWage;
    if (minWage && wage !== null && wage < minWage) wage = minWage;
    con.recruits.push({
      id: null,
      cdSite: con.cdSite,
      cdContract: con.cdContract,
      employmentSecurityOffice: last ? last.employmentSecurityOffice : '',
      startDateRecruit: '',
      endDateRecruit: '',
      medium: last ? last.medium : 'ハローワーク',
      status: '2',
      wage: wage,
      requestNo: '',
      isNew: true,
      // 新しい行は最初から保存できる
      dirty: true
    });
  }

  /**
   * 物件の最寄り駅と徒歩（分）を保存（RP の物件概要書に書く）
   */
  saveSiteStation(site: RecruitSite) {
    const minutes = site.walkMinutes === null || site.walkMinutes === undefined || String(site.walkMinutes) === '' ? '' : Number(site.walkMinutes);
    site.stationSaving = true;
    this.http.post(
      API_BASE_URL + "/api/v1/recruit/siteStation?cdSite=" + encodeURIComponent(site.cdSite)
        + "&nearestStation=" + encodeURIComponent(site.nearestStation || '')
        + "&walkMinutes=" + minutes
        + "&nameSite=" + encodeURIComponent(site.nameSite),
      null, this.httpOptions
    ).subscribe(res => {
      site.stationSaving = false;
      site.stationDirty = false;
      if (minutes === '') site.walkMinutes = null;
    }, error => {
      site.stationSaving = false;
      if (this.isSignOut(error)) return;
      alert('最寄り駅の保存に失敗しました。一覧を取り直します。');
      this.getRecruitData();
    });
  }

  /**
   * 募集開始日を入れたら、終了日が空なら「開始日の2か月後の月末」を入れる
   */
  changeStart(r: Recruit) {
    if (r.startDateRecruit && !r.endDateRecruit) {
      r.endDateRecruit = moment(r.startDateRecruit).add(2, 'M').endOf('month').format('YYYY-MM-DD');
    }
  }

  /**
   * 保存時チェック
   */
  validate(r: Recruit): boolean {
    if (!r.startDateRecruit) {
      alert('募集開始日を入れてください。');
      return false;
    }
    if (!r.endDateRecruit) {
      alert('募集終了日を入れてください。');
      return false;
    }
    if (r.endDateRecruit < r.startDateRecruit) {
      alert('募集終了日が募集開始日より前になっています。');
      return false;
    }
    if (!r.employmentSecurityOffice && r.medium == 'ハローワーク') {
      if (!window.confirm('ハローワーク番号が未入力ですがよろしいでしょうか？')) {
        return false;
      }
    }
    if (!r.medium) {
      if (!window.confirm('募集媒体が未入力ですがよろしいでしょうか？')) {
        return false;
      }
    }
    return true;
  }

  /**
   * 募集の行を保存
   */
  saveRecruit(site: RecruitSite, con: RecruitContract, r: Recruit) {
    if (!this.validate(r)) {
      return;
    }
    // 時給が県別の最低賃金を下回っていたら、知らせて最低賃金に書き直してから保存する（決定＝完了のときは見ない）
    if (r.status != '1' && site.minWage && r.wage !== null && r.wage !== undefined && String(r.wage) !== '' && Number(r.wage) < Number(site.minWage)) {
      alert('時給 ' + this.amountFormat(r.wage) + ' 円は、' + site.minWagePref + 'の最低賃金 ' + this.amountFormat(site.minWage) + ' 円を下回っています。\n最低賃金に書き直して保存します。');
      r.wage = Number(site.minWage);
    }
    // 「決定」は募集の完了。保存すると履歴に移る
    if (r.status == '1') {
      if (!window.confirm('この募集は完了とします。よろしいですか？\n（完了した募集は「履歴」で見られます）')) {
        return;
      }
    }
    r.saving = true;
    const body = {
      id: r.id,
      cdSite: con.cdSite,
      cdContract: con.cdContract,
      employmentSecurityOffice: r.employmentSecurityOffice,
      startDateRecruit: r.startDateRecruit,
      endDateRecruit: r.endDateRecruit,
      medium: r.medium,
      status: Number(r.status),
      wage: r.wage === null || r.wage === undefined || String(r.wage) === '' ? null : Number(r.wage),
      requestNo: r.requestNo,
      createdUser: localStorage.getItem("uid")
    };

    this.http.post(
      API_BASE_URL + "/api/v1/recruit/save?nameSite=" + encodeURIComponent(site.nameSite), body, this.httpOptions
    ).subscribe((res: any) => {
      // 成功したら一覧は取り直さず、その行だけ保存済みにする（並びが変わったり、ほかの行の入力が消えたりしないように）
      r.saving = false;
      r.dirty = false;
      r.isNew = false;
      if (res && res.id) r.id = res.id;
      // 決定で保存した行は完了。履歴へ移す（バックが論理削除している）
      if (r.status == '1') {
        r.deleteDate = res && res.deleteDate ? res.deleteDate : moment().format();
        con.recruits.splice(con.recruits.indexOf(r), 1);
        con.history.unshift(r);
      }
    }, error => {
      r.saving = false;
      if (this.isSignOut(error)) return;
      alert('保存に失敗しました。一覧を取り直します。');
      // 画面と DB がずれている可能性があるので取り直す
      this.getRecruitData();
    });
  }

  /**
   * 削除ボタン（確認してから消す）
   */
  confirmDelete(site: RecruitSite, con: RecruitContract, r: Recruit) {
    // 一度も保存していない行は消すだけ
    if (!r.id) {
      con.recruits.splice(con.recruits.indexOf(r), 1);
      return;
    }
    if (window.confirm('この募集を削除しますか？\n（削除した募集は「履歴」に残ります）')) {
      this.deleteRecruit(site, con, r);
    }
  }

  /**
   * 募集の行を削除（論理削除。履歴に残る）
   */
  deleteRecruit(site: RecruitSite, con: RecruitContract, r: Recruit) {
    r.saving = true;
    this.http.post(
      API_BASE_URL + "/api/v1/recruit/remove?nameSite=" + encodeURIComponent(site.nameSite), r.id, this.httpOptions
    ).subscribe(res => {
      // 成功したら一覧は取り直さず、その行を履歴へ移す
      r.saving = false;
      r.deleteDate = moment().format();
      con.recruits.splice(con.recruits.indexOf(r), 1);
      con.history.unshift(r);
    }, error => {
      r.saving = false;
      if (this.isSignOut(error)) return;
      alert('削除に失敗しました。一覧を取り直します。');
      this.getRecruitData();
    });
  }

  /**
   * 稼働管理を別タブで開く（この物件名で絞る）
   */
  openOperation(site: RecruitSite) {
    const url = location.origin + location.pathname + '#/operations/false?siteName=' + encodeURIComponent(site.nameSite || '');
    window.open(url, '_blank', 'noopener');
  }

  /**
   * 近くの清掃員を MAP で探す（物件名と、住所の市区町村までを入れて検索する）
   */
  openMap(site: RecruitSite) {
    this.dialog.open(MapDialogComponent, {
      maxWidth: '95vw',
      data: {
        siteName: site.nameSite,
        address: this.cityPart(site.address)
      }
    });
  }

  /**
   * 住所の市区町村まで（例：東京都江東区東雲1-1-1 → 東京都江東区）
   */
  cityPart(address: string): string {
    if (!address) return '';
    const m = address.match(/^(.{2,3}?[都道府県])?(.+?[市区町村])/);
    return m ? m[0] : address;
  }

  /**
   * ハローワーク番号の入力：数字と「-」以外は消す（type=tel はキーボードを変えるだけで文字を止めない）
   */
  telOnly(value: string): string {
    return (value || '').replace(/[^0-9-]/g, '');
  }

  /**
   * 金額を3桁区切りにする
   */
  amountFormat(val) {
    if (val === null || val === undefined || val === '') {
      return '';
    } else {
      return Number(val).toLocaleString();
    }
  }

  /**
   * 時間の数字（小数2桁まで。末尾の 0 は出さない。四捨五入はしない）
   */
  num(val): string {
    if (val === null || val === undefined) return '';
    return String(parseFloat(Number(val).toFixed(2)));
  }

  /**
   * 過不足の表示（符号付き。マイナスは −）
   * @param val 数字
   * @param unit 単位（h/月・h/週）
   */
  hourText(val, unit: string): string {
    if (val === null || val === undefined) return '';
    const n = Number(val);
    if (n === 0) return '±0 ' + unit;
    return (n > 0 ? '+' : '−') + this.num(Math.abs(n)) + ' ' + unit;
  }

  /**
   * 履歴の1行の文言（決定で終わった募集は「完了」、それ以外は「削除」）
   */
  historyText(r: Recruit): string {
    const period = (r.startDateRecruit ? moment(r.startDateRecruit).format('YYYY/MM/DD') : '') + '〜' + (r.endDateRecruit ? moment(r.endDateRecruit).format('YYYY/MM/DD') : '');
    const when = r.deleteDate ? moment(r.deleteDate).format('YYYY/MM/DD HH:mm') + ' ' : '';
    return period + '　' + (r.medium || '') + '　' + (r.wage ? this.amountFormat(r.wage) + ' 円' : '') + '　' + when + (r.status == '1' ? '完了（清掃員決定）' : '削除');
  }

  /**
   * エクスポート（今の検索条件で全部。契約×募集の行）
   */
  downloadBtn() {
    this.downloading = true;

    this.http.get(
      API_BASE_URL + '/api/v1/recruit/allData?' + this.queryString(),
      {headers: this.headers}
    )
    .subscribe(res => {
      const data = (res as RecruitSite[]) || [];
      const rows = [];
      data.forEach(site => {
        this.prepareSite(site);
        site.contracts.forEach(con => {
          // 条件に当たった契約だけ出す
          if (!con.hit) return;
          const recruits = con.recruits.length > 0 ? con.recruits : [null];
          recruits.forEach(r => {
            rows.push({
              '物件名': site.nameSite,
              '得意先': site.client1,
              '支店名': site.client2,
              '郵便番号': site.zip,
              '住所': site.address,
              '最寄り駅': site.nearestStation || '',
              '徒歩(分)': site.walkMinutes === null || site.walkMinutes === undefined ? '' : site.walkMinutes,
              '物件コード': site.cdSite,
              '契約コード': con.cdContract,
              '作業内容': con.workName,
              '状態': this.stateNames[con.state],
              '物件の過不足(h/月)': site.siteDiffM,
              '物件の過不足(h/週)': site.siteDiff,
              'この契約の不足(h/月)': con.shortTotal,
              'この契約の不足(h/週)': con.shortTotalWeek,
              '不足曜日': this.shortDays(con).map(w => w.name + ' ' + con[w.text]).join('、'),
              'いつから不足': con.shortFrom || '',
              '清掃員': (con.staffs || []).map(st => this.staffText(st)).join('、'),
              '月曜': con.mon, '火曜': con.tue, '水曜': con.wed, '木曜': con.thu, '金曜': con.fri, '土曜': con.sat, '日曜': con.sun,
              '時間指定': con.specificTime == 1 ? '有り' : '無し',
              'ゴミ搬出': con.garbage == 1 ? '有り' : '無し',
              '祝日勤務': this.holidayText(con.holiday).replace('祝日', '').trim(),
              '全社休日出勤': con.companyHoliday == 1 ? '有り' : '無し',
              '月額': this.amountFormat(con.monthlyFee),
              '月時間': con.monthlyHours,
              '時給単価': this.amountFormat(con.hourlyWage),
              '最低賃金': con.minWage ? this.amountFormat(con.minWage) : '',
              '募集媒体': r ? r.medium : '',
              'ハローワーク管理番号': r ? r.employmentSecurityOffice : '',
              '募集開始': r && r.startDateRecruit ? moment(r.startDateRecruit).format('YYYY/MM/DD') : '',
              '募集終了': r && r.endDateRecruit ? moment(r.endDateRecruit).format('YYYY/MM/DD') : '',
              '時給': r ? r.wage : '',
              '清掃員決定': r ? (r.status == '1' ? '決定' : '未決定') : '',
              '問い合わせNo': r ? r.requestNo : ''
            });
          });
        });
      });

      if (rows.length > 0) {
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, '欠員募集' + moment().format('YYYYMMDD') + '.xlsx');
      } else {
        alert('出力するデータがありません。');
      }
      this.downloading = false;
    },
    error => {
      this.downloading = false;
      if (this.isSignOut(error)) return;
      alert('エクスポートに失敗しました。');
    });
  }
}
